import React, { useEffect } from 'react'
import styles from './balls-game-instruction.module.css';
import { useSelector } from 'react-redux';

export default function BallsGameInstruction(props) {

    const gameData = useSelector((state) => state?.game?.gameData)


    //sounds
    const buttonClickAudio = new Audio('../sound/click-for-game-menu-131903.mp3');

    const getStartedHandler = async () => {
        await props.setIsBackgroundAudioPlaying(true)
        await buttonClickAudio.play()
        props.setCurrentStep("passcode")
    }


    return (
        <>
            <div className='container-fluid row flex-column align-items-center justify-content-center' style={{ minHeight: '100vh' }}>
                <div>
                    <div className='pt-3'>
                        <img src={gameData?.company?.company_logo} width={150} className='img-fluid py-2' alt="company" />
                    </div>
                    <div className='pt-3'>
                        <img src={gameData?.game?.game_data?.game_logo} width={210} className='img-fluid py-2' alt="company" />
                    </div>
                    <div className='pt-3'>
                        <h1 className='futura-bold text42526a'>{gameData?.game?.title}</h1>
                        <h3 className='futura-medium text42526a'>{gameData?.game?.sub_title}</h3>
                    </div>
                    <div className='text42526a pt-3'>
                        <h2 className='fw-bold h1'>{props?.gameAllData?.game?.title}</h2>
                        <h4>{props?.gameAllData?.game?.desc}</h4>
                    </div>


                    <div className='container-fluid py-3'>
                        <div className='row'>
                            <div className='col-lg-8 offset-lg-2 text-center px-lg-5'>

                                <div className='row justify-content-center'>

                                    <div className='col-lg-4 col-md-4 col-8 mb-4 d-flex justify-content-center'>
                                        <div>
                                            <div className={styles.step_card_wrapper}>
                                                <div className={styles.card_image_wrapper}>
                                                    <img src={gameData?.game?.game_data?.game_step_1?.image} className='img-fluid' alt="first step" />
                                                </div>
                                            </div>
                                            <div className='text-42526a'>
                                                <h4 className='fw-bold mb-1'>Step 1</h4>
                                                <p>{gameData?.game?.game_data?.game_step_1?.title}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-4 col-md-4 col-8 mb-4 d-flex justify-content-center'>
                                        <div>
                                            <div className={styles.step_card_wrapper}>
                                                <div className={styles.card_image_wrapper}>
                                                    <img src={gameData?.game?.game_data?.game_step_2?.image} alt="Second step" className='img-fluid' />
                                                </div>
                                            </div>
                                            <div className='text-42526a'>
                                                <h4 className='fw-bold mb-1'>Step 2</h4>
                                                <p> {gameData?.game?.game_data?.game_step_2?.title}</p>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='col-lg-4 col-md-4 col-8 mb-4 d-flex justify-content-center'>
                                        <div>
                                            <div className={styles.step_card_wrapper}>
                                                <div className={styles.card_image_wrapper}>
                                                    <img src={gameData?.game?.game_data?.game_step_3?.image} className='img-fluid' alt="Third step" />
                                                </div>
                                            </div>
                                            <div className='text-42526a'>
                                                <h4 className='fw-bold mb-1'>Step 3</h4>
                                                <p>{gameData?.game?.game_data?.game_step_3?.title}</p>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>

                        <div className='my-4'>
                            <button className='secondary-button' onMouseDown={() => { getStartedHandler() }}>GET CRACKIN’</button>
                        </div>
                    </div>

                </div>
            </div>


        </>
    )
}
